import svgPaths from '../imports/svg-vkt7hpc6si';
import imgImage2 from '@/assets/3d2866b91c2935a1b27b8e73ec960d662204b751.png';
import imgImage220 from '@/assets/5e4baee7958838f23e9a8b7dd51da4a94759b9d1.png';

function RelatedServiceList() {
  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 lg:gap-8">
      <a
        href="https://novasell.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs sm:text-sm hover:underline"
      >
        ノバセル（広告のプラットフォーム）
      </a>
      <a
        href="https://hacobell.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs sm:text-sm hover:underline"
      >
        ハコベル（物流のプラットフォーム）
      </a>
      <a
        href="https://www.notosiki.co.jp/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs sm:text-sm hover:underline"
      >
        ダンボールワン（梱包材のプラットフォーム）
      </a>
    </div>
  );
}

function RelatedServiceList1() {
  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 lg:gap-8">
      <a
        href="https://peraichi.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs sm:text-sm hover:underline"
      >
        ペライチ（ホームページ作成/予約/決済）
      </a>
      <a
        href="https://raksulbank.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs sm:text-sm hover:underline"
      >
        ラクスルバンク（金融のプラットフォーム）
      </a>
    </div>
  );
}

function RelatedServiceLinks() {
  return (
    <div className="flex flex-col gap-2 sm:gap-3 font-['Hiragino_Sans',sans-serif] text-xs sm:text-sm font-normal">
      <RelatedServiceList />
      <RelatedServiceList1 />
    </div>
  );
}

function RelatedService() {
  return (
    <div className="flex w-full flex-col items-start gap-2 text-[#636363]">
      <p className="font-['Hiragino_Sans',sans-serif] text-xs sm:text-sm font-semibold">
        関連のサービス
      </p>
      <RelatedServiceLinks />
    </div>
  );
}

function Group() {
  return (
    <div className="absolute inset-[18.87%_0.15%_9.81%_28.04%]">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 84.0196 32.0945"
      >
        <g id="Group">
          <path d={svgPaths.p561acf0} fill="black" id="Vector" />
          <path d={svgPaths.p3d782600} fill="black" id="Vector_2" />
          <path d={svgPaths.p18827700} fill="black" id="Vector_3" />
          <path d={svgPaths.p20040680} fill="black" id="Vector_4" />
          <path d={svgPaths.p3c6d8500} fill="black" id="Vector_5" />
        </g>
      </svg>
    </div>
  );
}

function Group1() {
  return (
    <div className="absolute inset-[21.7%_74.78%_12.64%_0]">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 29.5052 29.5472"
      >
        <g id="Group">
          <path d={svgPaths.p14594aa0} fill="black" id="Vector" />
          <g id="XMLID_12_">
            <path d={svgPaths.p25c200} fill="#00A0E8" id="Vector_2" />
          </g>
          <g id="XMLID_11_">
            <path d={svgPaths.p12fe26c0} fill="#00A0E8" id="Vector_3" />
          </g>
          <path d={svgPaths.p2969ff00} fill="#E4007E" id="Vector_4" />
          <g id="XMLID_10_">
            <path d={svgPaths.p408a200} fill="#FEF300" id="Vector_5" />
          </g>
          <g id="XMLID_9_">
            <path d={svgPaths.p2bffc280} fill="#FEF300" id="Vector_6" />
          </g>
          <path d={svgPaths.p38afa300} fill="black" id="Vector_7" />
        </g>
      </svg>
    </div>
  );
}

function RaksulLogo() {
  return (
    <div className="relative h-[36px] w-[90px] sm:h-[45px] sm:w-[117px] shrink-0 overflow-clip">
      <Group />
      <Group1 />
    </div>
  );
}

function RelatedLink() {
  return (
    <div className="flex shrink-0 flex-col items-start gap-1 sm:gap-2 font-['Hiragino_Sans',sans-serif] text-[10px] sm:text-xs font-normal leading-relaxed text-[#636363]">
      <a
        href="https://corp.raksul.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        運営会社について
      </a>
      <a
        href="https://raksul.com/law/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        特定取引法に基づく表記
      </a>
      <a
        href="https://corp.raksul.com/security-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        情報セキュリティ基本方針
      </a>
      <a
        href="https://corp.raksul.com/esg/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        ESGの取り組み
      </a>
    </div>
  );
}

function RelatedLink1() {
  return (
    <div className="flex shrink-0 flex-col items-start gap-1 sm:gap-2 font-['Hiragino_Sans',sans-serif] text-[10px] sm:text-xs font-normal leading-relaxed text-[#636363]">
      <a
        href="https://recruit.raksul.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        採用情報
      </a>
      <a
        href="https://corp.raksul.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        個人情報保護方針
      </a>
      <a
        href="https://raksul.com/print/cookie-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        Cookieポリシー
      </a>
    </div>
  );
}

function RelatedLink2() {
  return (
    <div className="flex shrink-0 flex-col items-start gap-1 sm:gap-2 font-['Hiragino_Sans',sans-serif] text-[10px] sm:text-xs font-normal leading-relaxed text-[#636363]">
      <a
        href="https://raksul.com/rules/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        ラクスルサービス利用規約
      </a>
      <a
        href="https://raksul.com/privacy/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        個人情報の取り扱い
      </a>
      <a
        href="https://raksul.com/rules/other-trademark/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        他社商標
      </a>
    </div>
  );
}

function LogoRelatedlink() {
  return (
    <div className="flex flex-col sm:flex-row flex-wrap items-start gap-4 sm:gap-6 lg:gap-12 xl:gap-16">
      <RaksulLogo />
      <div className="flex flex-wrap gap-4 sm:gap-6 lg:gap-10 xl:gap-16">
        <RelatedLink />
        <RelatedLink1 />
        <RelatedLink2 />
      </div>
    </div>
  );
}

function PrivacyImageContainer() {
  return (
    <div className="flex shrink-0 items-center gap-2 sm:gap-3">
      <div className="relative w-10 h-10 sm:w-[50px] sm:h-[50px] shrink-0">
        <img
          alt="プライバシーマーク"
          className="pointer-events-none absolute inset-0 size-full max-w-none object-cover object-center"
          src={imgImage2}
        />
      </div>
      <div className="relative h-9 w-[54px] sm:h-[45px] sm:w-[67px] shrink-0">
        <img
          alt="ISMS認証"
          className="pointer-events-none absolute inset-0 size-full max-w-none object-cover object-center"
          src={imgImage220}
        />
      </div>
    </div>
  );
}

function Section() {
  return (
    <div className="flex w-full flex-col lg:flex-row items-start lg:items-start justify-between gap-4 lg:gap-8">
      <LogoRelatedlink />
      <PrivacyImageContainer />
    </div>
  );
}

function Section1() {
  return (
    <div className="flex flex-col items-start gap-1 text-[8px] sm:text-[10px]">
      <p className="font-['Hiragino_Sans',sans-serif] text-[#636363]">
        ネット印刷会員数No.1 東京商工リサーチ調べ（2022年12月時点/主要ネット印刷サービスにおいて）
      </p>
      <p className="font-['Roboto',sans-serif] font-normal text-[#646c75]">
        © 2025 RAKSUL INC. All Rights Reserved.
      </p>
    </div>
  );
}

function Separator() {
  return (
    <div className="w-full h-px bg-[#DCDCDC]" />
  );
}

export function GlobalFooter() {
  return (
    <footer className="flex w-full flex-col items-start gap-4 sm:gap-6 bg-[#f5f6f6] px-4 sm:px-6 lg:px-10 pb-4 pt-4 sm:pt-6">
      <RelatedService />
      <Separator />
      <Section />
      <Separator />
      <Section1 />
    </footer>
  );
}
